import { TAO_KOE } from './../libs';

// Search Animation Handler Class.
class SearchAnimationHandler {
	// Check if Animation is running.
	isRunning = false;

	terms = [];
	i18n = {};

	constructor( terms = [], i18n = {} ) {
		this.terms = terms;
		this.i18n = i18n;

		// Events for Search.
		document.addEventListener( 'open_searchbox.sl', () => this.stopAnimation() );
		document.addEventListener( 'close_searchbox.sl', () => this.startAnimation() );
	}

	/**
	 * Set the placeholder for relevant input elements.
	 *
	 * @param {string} placeholder
	 */
	setPlaceholder( placeholder ) {
		const inputEls = document.querySelectorAll( '.mdl_search__input' );
		inputEls.forEach( ( inputEl ) => inputEl.placeholder = placeholder );
	}

	/**
	 * Set Terms to use for animation at a later time.
	 *
	 * @param {Array} terms
	 */
	setTerms( terms ) {
		this.terms = terms || [];
	}

	/**
	 * Set Translations strings.
	 *
	 * @param {Object} i18n
	 */
	setTranslation( i18n ) {
		this.i18n = i18n || {};
	}

	/**
	 * Spell a Term into the searcharea.
	 *
	 * @param {string} term The term to write.
	 * @return {void}
	 */
	writeTerm( term ) {
		let index = 0;
		const interval = setInterval( () => {
			this.setPlaceholder( ( this.i18n.searching || 'Ich suche... %s' ).replace( '%s', term.slice( 0, index ) ) );

			// Animation was stopped.
			if ( ! this.isRunning ) {
				clearInterval( interval );
				this.setPlaceholder( this.i18n.placeholder || 'Was suchen Sie?' );
				return;
			}

			if ( index < term.length ) {
				index++;
			} else {
				// Clear Interval and restart.
				clearInterval( interval );

				setTimeout( () => {
					this.setPlaceholder( this.i18n.placeholder || 'Was suchen Sie?' );

					setTimeout( () => {
						this.doAnimation();
					}, 2000 );
				}, 3000 );
			}
		}, 100 + ( Math.random() * 250 ) );
	}

	/**
	 * Start the Animation.
	 *
	 * @return {boolean} Whether the animation is running.
	 */
	startAnimation() {
		// Stop a new run - we are already running.
		if ( this.isRunning ) {
			return this.isRunning;
		}

		// Do not start when the terms are empty.
		if ( this.terms.length <= 0 ) {
			return false;
		}

		this.isRunning = true;
		this.doAnimation();

		return this.isRunning;
	}

	/**
	 * Do the Animation - Stops if not running.
	 *
	 * @return {boolean} Whether the animation is running.
	 */
	doAnimation() {
		if ( ! this.isRunning ) {
			return this.isRunning;
		}

		const terms = this.terms;
		setTimeout( () => {
			const term = terms[ Math.floor( Math.random() * terms.length ) ];
			this.writeTerm( term );
		}, 2000 );

		return this.isRunning;
	}

	/**
	 * Stop the current Animation and wait for a new init.
	 *
	 * @return {boolean} Whether the animation is running.
	 */
	stopAnimation() {
		this.isRunning = false;
		return this.isRunning;
	}
}

// There can only be one instance.
const SearchAnimation = new SearchAnimationHandler();

/**
 * Utility function for A/B Testint Tool - Exposes initialisation
 *
 * @param {Array}  terms Array of Terms.
 * @param {Object} i18n  Map of Translation strings.
 * @return {Object}     Instance of the Searchanimation.
 */
const initSearchAnimation = ( terms, i18n ) => {
	// Set Terms.
	if ( 'undefined' !== typeof terms ) {
		SearchAnimation.setTerms( Object.values( terms ) );
	}
	if ( 'undefined' !== typeof i18n ) {
		SearchAnimation.setTranslation( i18n );
	}

	// Start Animation.
	SearchAnimation.startAnimation();
	return SearchAnimation;
};

/**
 * Initialise Searchanimation.
 */
TAO_KOE.ready( 'searchanim.js', function() {
	// Check if Searchanimation Settings exist.
	if ( ! TAO_KOE.hasOwnProperty( 'Searchanimation' ) ) {
		return;
	}

	if ( ! TAO_KOE.Searchanimation ) {
		return;
	}

	// Check if they are active.
	if ( ! TAO_KOE.Searchanimation.is_active ) {
		return;
	}

	// Default initialisiation.
	initSearchAnimation( TAO_KOE.Searchanimation.terms, TAO_KOE.Searchanimation.i18n ?? {} );
} );

// Expose.
TAO_KOE.SearchAnimationHandler = SearchAnimation;

// Export.
export {
	SearchAnimation as default,
	initSearchAnimation,
};
